import React, { useEffect, useState } from 'react';
import { CardBody } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '..';
import { getVoyagesAction, setVesselState, setVoyageID } from "../Store/Generic/ReportingSlice";
import { queryKeyes } from 'shared/queryKeys';
import { useQuery } from 'react-query';
import Loading from 'Components/Loading';
import ErrorComponent from 'Components/ErrorComponent';
import VoyageTableHeadComponent from './VoyageTableHeadComponent';
import PageNavButton from 'Dashboard/PendingFiles/PageNavButton';
import { GetPageWithID } from 'Dashboard/PendingFiles/pendingpage.hook';
import PopUp from 'Components/PopUp';
import CompletedReports from 'VesselReportingInfo/CompletedReports';
import ToolTip from 'Components/ToolTip';
import VoyageAnalysis from './VoyageAnalysis';
import { dateTimeFormat, formattooltip } from 'GenericForms/Helper';
import Message from 'Components/Message';
import TableLoading from 'Components/TableLoading';
import voyageanalysis from '../Media/voyage-timeline.png';
import ViewReport from '../Media/VD2.png'
import { hasRole } from 'utils/auth/authUtils';
import { Order, Roles } from 'shared/constants';
import env from 'environment_system/env_system';

const PreviousVoyages = ({
    setActiveVoyageTab
}: any) => {
    /** State variables */
    const dispatch = useDispatch();
    const { VesselID, VesselState } = useSelector((state: RootState) => state.Reporting);
    const [pageUrl, setPageUrl] = useState<string>('');
    const [state, setState] = useState<boolean>(false);
    const [voyageNumber, setVoyageNumber] = useState<boolean>(null);
    const [hoverId, setHoverId] = useState<string | null>(null);
    const [order, setOrder] = useState<string>(Order.ASC);
    /** State variables end */

    /** useEffect */
    useEffect(() => {
        setPageUrl(queryKeyes.pagination.VoyageListPage.url(VesselID, order));
    }, [VesselID, order])
    useEffect(() => {
        dispatch(getVoyagesAction('voyage_information' as string));
    }, [dispatch]);
    /** useEffect end */

    /** useQuery */
    const { data: voyages, isFetching: voyagesFetching, isError: voyagesError } = useQuery(
        [queryKeyes.pagination.VoyageListPage.key, pageUrl, VesselID],
        async () => await GetPageWithID(VesselID, pageUrl),
        {
            enabled: true,
            staleTime: Infinity,
        }
    )
    /** useQuery end */
    return (
        <React.Fragment>
            <div className='ele_row mb-4'>
                <h4 id='owner_table'>Voyage Reporting Information </h4>
            </div>
            <CardBody className='p-0'>
                <div className="table-responsive" id='owner_table'>
                    {(voyagesFetching) && (
                        <TableLoading />
                    )}
                    {voyagesError && (
                        <ErrorComponent message='Unable to load voyage list!' />
                    )}
                    {(!voyagesFetching && !voyagesError) &&
                        <table className="table mb-0">
                            <VoyageTableHeadComponent setOrder={setOrder} order={order} tab={2} previousVoyage={true}/>
                            <tbody>
                                {(voyagesFetching) && (
                                    <tr>
                                        <tr>
                                            <td colSpan={4}>
                                                <Loading message='Loading required data!' />
                                            </td>
                                        </tr>
                                    </tr>
                                )}
                                {voyagesError && (
                                    <tr>
                                        <tr>
                                            <td colSpan={4}>
                                                <ErrorComponent message='Unable to load required data!' />
                                            </td>
                                        </tr>
                                    </tr>
                                )}
                                {voyages?.results?.length > 0 ? (
                                    voyages.results.map((voyage: any, index: number) => (
                                        <tr key={voyage.id}>
                                            <td className="p-2 align-middle text-center">{index + 1}</td>
                                            <td className="p-2 align-middle">{voyage.voyage_number}</td>
                                            <td className="p-2 align-middle text-left">{dateTimeFormat(voyage?.departure_date_time, false, false, true)}</td>
                                            <td className="p-2 align-middle text-left">
                                                {dateTimeFormat(voyage?.voyage_end_date_time, false, false, true)}
                                                </td>
                                            <td className="p-2 align-middle text-center">
                                                {hasRole(Roles.ES_ADMIN) && env.inDevelopment && (
                                                    <i
                                                        className="bx bx-calendar-edit pointer icon_s32 color-assign-user align-middle me-3"
                                                        id={`Off_hire_${voyage.id}`}
                                                        onMouseEnter={() => setHoverId(`Off_hire_${voyage.id}`)}
                                                        onMouseLeave={() => setHoverId(null)}
                                                        onClick={() => {
                                                            dispatch(setVesselState('OFF_HIRE'));
                                                        }}
                                                    />
                                                )}
                                                <img
                                                    id={`View_voyage_reports_${voyage?.id}`}
                                                    src={ViewReport}
                                                    alt="View Voyage Reports"
                                                    className="pointer me-3"
                                                    height="28"
                                                    onClick={() => {
                                                        setState(true);
                                                        setVoyageNumber(voyage.voyage_number);
                                                        dispatch(setVoyageID(voyage.id));
                                                    }}
                                                    onMouseEnter={() => setHoverId(`View_voyage_reports_${voyage?.id}`)}
                                                    onMouseLeave={() => setHoverId(null)}
                                                />
                                                <img
                                                    id={`Voyage_analysis_${voyage?.id}`}
                                                    src={voyageanalysis}
                                                    height="40"
                                                    width={45}
                                                    className="pointer"
                                                    alt="Voyage Analysis"
                                                    onClick={() => {
                                                        setVoyageNumber(voyage.voyage_number);
                                                        dispatch(setVesselState('VOYAGE_ANALYSIS'));
                                                        dispatch(setVoyageID(voyage.id));
                                                    }}
                                                    onMouseEnter={() => setHoverId(`Voyage_analysis_${voyage?.id}`)}
                                                    onMouseLeave={() => setHoverId(null)}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={8}>
                                            <Message message="No voyages found for this vessel." type={'danger'} />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    {voyages?.results?.length > 0 &&
                                        <td colSpan={5} className="p-2 ">
                                            <PageNavButton setPageUrl={setPageUrl} pageobj={voyages} pageUrl={pageUrl} />
                                        </td>
                                    }
                                </tr>
                            </tfoot>
                        </table>
                    }
                </div>
            </CardBody>
            <PopUp
                state={state}
                setState={setState}
                body={
                    <CompletedReports
                        isPreviousVoyage={true}
                    />
                }
                title={`Voyage: ${voyageNumber}`}
                size="xl"
            />
            {hoverId !== null &&
                <ToolTip
                    target={hoverId}
                    message={formattooltip(hoverId)}
                    isOpen={hoverId !== null}
                />
            }

            {VesselState === "VOYAGE_ANALYSIS" &&
                <VoyageAnalysis
                    setActiveVoyageTab={setActiveVoyageTab}
                />}
        </React.Fragment>
    )
}

export default PreviousVoyages